import instance from "../instance";


export const notificationsApi = {
  getNotifications: () => instance.get('/v1/notifications/notifications'),
  readNotification: (notificationId, is_active) => instance.patch(`/v1/notifications/notifications/${notificationId}?is_delivered=true&is_active=${is_active}&verbose_level=2`)
}